import { QuestionBase } from './question-base';
/*

Sample:

new ImagecropperQuestion({
  key: 'picture',
  label: 'nouns.profilePicture',
  value: student ? { image: student.picture } : {},
  order: 6
})

*/
export class ImageUploaderSmall extends QuestionBase<Object> {
  controlType = 'imageuploadersmall';
  info: string;

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
  }
}
